<template>
  <section :class="$b()">
    <div :class="[$b('container'), 'global-wrapper']">
      <BaseHeading
        size="h1"
        tag="h2"
        :class="$b('title')"
      >
        Compare
        <br />
        Pace Series&trade;
      </BaseHeading>

      <div :class="$b('columns')">
        <div :class="$b('column-labels')">
          <p :class="$b('label')">
            {{ $tr('Lens Shape') }}
          </p>
          <p :class="$b('label')">
            {{ $tr('Frame Size') }}
          </p>
          <p :class="$b('label')">
            {{ $tr('Peripheral Vision') }}
          </p>
          <p :class="$b('label')">
            {{ $tr('Wind Protection') }}
          </p>
          <p :class="$b('label')">
            {{ $tr('Weight') }}
          </p>
          <p :class="$b('label')">
            {{ $tr('Lens Change') }}
          </p>
          <p :class="$b('label')">
            {{ $tr('Best For') }}
          </p>
        </div>

        <div :class="$b('column-product')">
          <div :class="$b('product-image')">
            <DynamicImg
              :sku="currentModel.imageSku"
              :view-angle="5"
              :width="338"
              :height="286"
              :scale="1.5"
              bg="transparent"
            />
          </div>
          <BaseHeading
            tag="h3"
            size="h2"
            :class="$b('product-title')"
          >
            {{ $tr(currentModel.model) }}
            <span :class="$b('product-subtitle')">
              {{ $tr(currentModel.frameType) }}
            </span>
          </BaseHeading>
          <p :class="$b('label')">
            {{ $tr('Lens Shape') }}
          </p>
          <p :class="$b('attribute')">
            {{ $tr(currentModel.lensShape) }}
          </p>
          <p :class="$b('label')">
            {{ $tr('Frame Size') }}
          </p>
          <p :class="$b('attribute')">
            {{ $tr(currentModel.frameSize) }}
          </p>
          <p :class="$b('label')">
            {{ $tr('Peripheral Vision') }}
          </p>
          <p :class="$b('attribute')">
            {{ $tr(currentModel.peripheralVision) }}
          </p>
          <p :class="$b('label')">
            {{ $tr('Wind Protection') }}
          </p>
          <p :class="$b('attribute')">
            {{ $tr(currentModel.windProtection) }}
          </p>
          <p :class="$b('label')">
            {{ $tr('Weight') }}
          </p>
          <p :class="$b('attribute')">
            {{ $tr(currentModel.weight) }}
          </p>
          <p :class="$b('label')">
            {{ $tr('Lens Change') }}
          </p>
          <p :class="$b('attribute')">
            {{ $tr(currentModel.lensChange) }}
          </p>
          <p :class="$b('label')">
            {{ $tr('Best For') }}
          </p>
          <p :class="$b('attribute')">
            <span :class="$b('desktop-only')">
              {{ $tr(currentModel.bestFor) }}
            </span>
            <!-- eslint-disable vue/no-v-html -->
            <span
              :class="$b('mobile-only')"
              v-html="addLineBreaks(currentModel.bestFor)"
            />
            <!-- eslint-enable vue/no-v-html -->
          </p>
        </div>

        <div
          v-if="selectedModel"
          :class="$b('column-product')"
        >
          <div :class="$b('product-image')">
            <DynamicImg
              :sku="selectedModel.imageSku"
              :view-angle="5"
              :width="338"
              :height="286"
              :scale="1.5"
              bg="transparent"
            />
          </div>
          <BaseHeading
            tag="h3"
            size="h2"
            :class="$b('product-title')"
          >
            {{ $tr(selectedModel.model) }}
            <span :class="$b('product-subtitle')">
              {{ $tr(selectedModel.frameType) }}
            </span>
          </BaseHeading>
          <p :class="$b('label')">
            {{ $tr('Lens Shape') }}
          </p>
          <p :class="$b('attribute')">
            {{ $tr(selectedModel.lensShape) }}
          </p>
          <p :class="$b('label')">
            {{ $tr('Frame Size') }}
          </p>
          <p :class="$b('attribute')">
            {{ $tr(selectedModel.frameSize) }}
          </p>
          <p :class="$b('label')">
            {{ $tr('Peripheral Vision') }}
          </p>
          <p :class="$b('attribute')">
            {{ $tr(selectedModel.peripheralVision) }}
          </p>
          <p :class="$b('label')">
            {{ $tr('Wind Protection') }}
          </p>
          <p :class="$b('attribute')">
            {{ $tr(selectedModel.windProtection) }}
          </p>
          <p :class="$b('label')">
            {{ $tr('Weight') }}
          </p>
          <p :class="$b('attribute')">
            {{ $tr(selectedModel.weight) }}
          </p>
          <p :class="$b('label')">
            {{ $tr('Lens Change') }}
          </p>
          <p :class="$b('attribute')">
            {{ $tr(selectedModel.lensChange) }}
          </p>
          <p :class="$b('label')">
            {{ $tr('Best For') }}
          </p>
          <p :class="$b('attribute')">
            <span :class="$b('desktop-only')">
              {{ $tr(selectedModel.bestFor) }}
            </span>
            <!-- eslint-disable vue/no-v-html -->
            <span
              :class="$b('mobile-only')"
              v-html="addLineBreaks(selectedModel.bestFor)"
            />
            <!-- eslint-enable vue/no-v-html -->
          </p>
          <div :class="$b('button-container')">
            <div :class="$b('button-inner')">
              <PrimaryButton
                :to="selectedModelUrl"
                :class="$b('product-button')"
                @click="updateFrameType"
              >
                {{ $tr(`Shop ${selectedModelName}`) }}
              </PrimaryButton>
              <PrimaryLineLink
                is-button
                invert
                :class="$b('product-select')"
                @click="showSelectModal"
              >
                {{ $tr('Select another Product') }}
              </PrimaryLineLink>
            </div>
          </div>
        </div>

        <div
          v-else
          :class="$b('column-product', { selectShowing: !selectedModel })"
        >
          <ComparisonSelectButton @click="showSelectModal" />
        </div>
      </div>

      <ComparisonSelectModal
        :visible="!!selectModalVisible && !!models"
        :filtered-model-list="filteredModelList"
        @new-selected-model="updateSelectedModel"
        @close="hideSelectModal"
      />
    </div>
  </section>
</template>

<script>
import CustomisedProduct from '~/models/CustomisedProduct'
import gqlQuery from '@/gql/product/paceComparison.gql.js'

export default {
  name: 'PaceComparison',
  props: {
    customisedProduct: {
      type: CustomisedProduct,
      required: true,
    },
    frameType: {
      type: String,
      required: true,
    },
  },
  async setup () {
    const { $sentry } = useNuxtApp()
    const { data: result, error } = await useDatoQuery({ query: gqlQuery })

    if (error.value) {
      $sentry.captureException(error)
      createError({
        statusCode: error.value.statusCode,
        statusMessage: error.value.statusMessage,
      })
    }

    return {
      result
    }
  },
  data: () => ({
    query: null,
    frameTypes: {
      zf: 'Zero Frame',
      tf: 'Top Frame',
      bf: 'Base Frame',
      ff: 'Full Frame',
    },
    selectedModelName: null,
    selectedFrameType: null,
    selectModalVisible: false,
  }),
  computed: {
    models () {
      return this.result.allPaceComparisons
    },
    currentModel() {
      if (!this.models) return
      const baseProductId = this.customisedProduct.product.baseProduct?.id
        || this.customisedProduct.product.id
      
      return this.models.filter((model) => {
        return (
          model.baseProduct.id === baseProductId &&
          model.frameType === this.frameTypes[this.frameType]
        )
      })[0]
    },
    filteredModelList() {
      if (!this.models) return
      return this.models.filter((model) => {
        return (
          model.model !== this.customisedProduct.product.name ||
          model.frameType !== this.frameTypes[this.frameType]
        )
      })
    },
    selectedModel() {
      if (!this.selectedModelName && !this.selectedFrameType) return null
      return this.models.filter((model) => {
        return (
          model.model === this.selectedModelName &&
          model.frameType === this.selectedFrameType
        )
      })[0]
    },
    selectedModelBaseSku() {
      if (!this.selectedModelName) return
      return this.selectedModelName.replace('™', '').toLowerCase()
    },
    selectedModelUrl() {
      if (!this.selectedModelBaseSku && !this.selectedFrameType) return
      return `/shop/sunglasses/${this.selectedModelBaseSku}?sku=${this.selectedModel.imageSku}`
    },
  },
  watch: {
    frameType() {
      this.resetSelectedModel()
    },
  },
  methods: {
    showSelectModal() {
      this.selectModalVisible = true
    },
    hideSelectModal() {
      this.selectModalVisible = false
    },
    updateSelectedModel({ modelName, frameType }) {
      this.selectedModelName = modelName
      this.selectedFrameType = frameType
      this.hideSelectModal()
    },
    addLineBreaks(textString) {
      return textString.replace(',', '<br />')
    },
    updateFrameType() {
      if (this.selectedModel.model !== this.currentModel.model) return
      this.customisedProduct.swapFrameType()
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
      this.resetSelectedModel()
    },
    resetSelectedModel() {
      this.selectedModelName = null
      this.selectedFrameType = null
      this.selectModalVisible = null
    },
  },
}
</script>

<style lang="postcss">
.PaceComparison {
  @apply bg-black pb-lg md:pb-xl md:px-sm lg:px-md;
}

.PaceComparison__container {
  @apply bg-black pb-lg md:pb-xl lg:px-xs mx-auto;
  max-width: 1320px;
}

.PaceComparison__title {
  @apply text-white
    mb-sm md:mb-md;
}

.PaceComparison__columns {
  @apply flex flex-row flex-nowrap justify-between items-stretch;
}

.PaceComparison__label {
  @apply text-white opacity-50 text-sm md:text-base leading-normal;
  padding-bottom: calc(theme('spacing.xxxs') / 2);
}

.PaceComparison__column-labels {
  @apply hidden lg:flex flex-col justify-end items-start flex-wrap
    pb-lg;
  min-width: 135px;
  width: 14%;
  padding-bottom: calc(theme('spacing.lg') * 2);

  .PaceComparison__label {
    @apply mb-sm pb-xxxs;
  }
}

.PaceComparison__column-product {
  @apply lg:bg-off-black flex flex-col justify-start lg:justify-end items-start flex-wrap
    px-xxxs xxs:px-xxs xs:px-xs sm:px-sm lg:px-md lg:pt-md;
  border-radius: 10px;
  flex: 1 1 100%;

  @screen sm {
    flex: 0 0 48%;
  }

  @screen lg {
    flex-basis: 40%;
    padding-bottom: calc(theme('spacing.lg') * 2);
  }

  @screen xl {
    padding-top: calc(theme('spacing.md') + theme('spacing.xs'));
    padding-left: calc(theme('spacing.md') + theme('spacing.xs'));
    padding-right: calc(theme('spacing.md') + theme('spacing.xs'));
  }

  &:nth-of-type(2) {
    @apply mdMax:pl-0;
  }

  &:last-of-type {
    @apply mdMax:pr-0;
  }

  &--select-showing {
    @apply justify-start;
  }

  .PaceComparison__label {
    @apply lg:hidden;
  }
}

.PaceComparison__product-image {
  @apply w-full md:w-5/6
    mx-auto pb-xs md:pb-xxs;

  img {
    @apply w-full h-auto;
  }
}

.PaceComparison__product-title {
  @apply text-white pb-md pt-sm lg:pt-md;
}

.PaceComparison__product-subtitle {
  @apply text-white text-sm lg:text-base font-normal
    block lg:inline;
}

.PaceComparison__attribute {
  @apply text-white text-sm md:text-base leading-normal font-semibold
    mb-sm lg:pb-xxxs;
}

.PaceComparison__button-container {
  @apply lg:relative w-full;

  .PaceComparison__product-button {
    @apply sm:mr-sm mb-sm sm:mb-md lg:mb-sm mt-sm px-xxs xxs:px-xs xs:px-sm;

    @screen sm {
      padding-left: 30px;
      padding-right: 30px;
    }
  }
}

.PaceComparison__button-inner {
  @apply lg:absolute w-full;
}

.PaceComparison__product-select {
  @apply whitespace-nowrap xxsMax:text-xs;
}

.PaceComparison__desktop-only {
  @apply hidden lg:inline;
}

.PaceComparison__mobile-only {
  @apply inline lg:hidden;
}
</style>
~/gql/product/paceComparison.gql.js